<template>
  <div class="page-content">
    <el-title :index="index + 2" :parent_data="active_study.etudeData.gie.sectionComplements"
					property="titre"
					:editable="true" style="margin-bottom: 5px">
			Compléments&nbsp;:
		</el-title>

    <el-checkbox
    v-if="editor.mode === 'editing'"
      :parent_data="active_study.etudeData.gie.sectionComplements"
      property="show_locaux_commerciaux_table"
      label="Afficher le tableau des locaux commerciaux"
      :editable="true"
    />

    <div v-if="active_study.etudeData.gie.sectionComplements.show_locaux_commerciaux_table" class="q-mb-md">
      <p class="label main_color_text">Locaux commerciaux</p>

      <el-table
        :table="locaux_commerciaux_table"
        :lines-obj="active_study.etudeData.gie.sectionComplements"
        lines-field="locaux_commerciaux_table_lines"
        lines-box-class="left lefter"
      />
    </div>

    <el-checkbox
    v-if="editor.mode === 'editing'"
      :parent_data="active_study.etudeData.gie.sectionComplements"
      property="show_bail_emphyteotique_table"
      label="Afficher le tableau de bail emphytéotique"
      :editable="true"
      class="q-mt-md"
    />

    <div v-if="active_study.etudeData.gie.sectionComplements.show_bail_emphyteotique_table">
      <p class="label main_color_text">Bail emphytéotique</p>

      <el-table
        :table="bail_emphyteotique_table"
        :lines-obj="active_study.etudeData.gie.sectionComplements"
        lines-field="bail_emphyteotique_table_lines"
        lines-box-class="left lefter"
        class="q-mb-md"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";


import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "page-gie-5",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
		};
	},
	props: ["index"],
	computed: {
		...mapGetters([
			"active_study",
			"app_parameters",
			"editor",
		]),
		locaux_commerciaux_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionComplements
					.locaux_commerciaux_table_lines
			);
		},
		locaux_commerciaux_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [22, 22, 28, 28],
				},
			};

			table.head.push([
				"Désignation",
				"Base locative",
				"Taux de rendements",
				"Valeur capitalisée",
			]);

			for (let i = 0; i < this.locaux_commerciaux_table_lines; i++) {
				const loc =
			this.active_study.etudeData.gie.sectionComplements
				.locaux_commerciaux_table[i];

				const rows = [
					{
						parent_data: loc,
						property: "designation",
						editable: true,
					},
					{
						parent_data: loc,
						property: "base_locative",
						editable: true,
					},
					{
						parent_data: loc,
						property: "taux_rendement",
						editable: true,
					},
					{
						parent_data: loc,
						property: "valeur_capitalisee",
						editable: true,
					},
				];

				table.body.push(rows);
			}

			return table;
		},
		bail_emphyteotique_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionComplements
					.bail_emphyteotique_table_lines
			);
		},
		bail_emphyteotique_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [35, 30, 35],
				},
			};

			table.head.push([
				"Valeur sol + constructions",
				"Nombre d'années écoulées",
				"valeur actuelle des droits acquis",
			]);

			for (let i = 0; i < this.bail_emphyteotique_table_lines; i++) {
				const loc =
			this.active_study.etudeData.gie.sectionComplements
				.bail_emphyteotique_table[i];

				const rows = [
					{
						parent_data: loc,
						property: "valeur_sol_construction",
						editable: true,
					},
					{
						parent_data: loc,
						property: "annees_ecoulees",
						editable: true,
					},
					{
						parent_data: loc,
						property: "valeur_actuelle_droits_acquis",
						editable: true,
					},
				];

				table.body.push(rows);
			}

			return table;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';
</style>
